// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"9cedf8c57d6b6f002dc9","883":"da19968e4b00979f9461"}[chunkId] + ".js";
};